<div edsGrid>
  <div edsSubGrid="layout-3" edsSpacing="md">
    <div edsFlexbox>
      <!-- Timeperiod dropdown -->
      <eds-dropdown
        label="{{ 'products.attribution-select-timeperiod' | translate }}"
        [items]="periodList"
        [titleText]="periodDropdownTitleText"
        [selectedText]="periodList[0]"
        (dropdownChange)="onTimePeriodChange($event, tabNumber)"
      ></eds-dropdown>

      &nbsp;&nbsp;&nbsp;&nbsp;

      <!-- Currency switch -->
      <div edsFlexbox alignItems="center">
        <label>{{
          "products.attribution-currency-toggle-label" | translate
        }}</label>

        <eds-switch
          [switchId]="'attribution-switch-tab-' + tabNumber"
          [disabled]="isWholeGridEmptyForSelectedDate ? true : false"
          [labelOff]="currencyToggleSwitch.labelOffKey"
          [labelOn]="currencyToggleSwitch.labelOnKey"
          [state]="currencyToggleSwitch.state"
          (switchPressed)="onCurrencyToggleChanged()"
        ></eds-switch>
      </div>
    </div>

    <div>
      <!-- Download button -->
      <button
        [edsButton]="'secondary'"
        [hasIcon]="true"
        (click)="onDownloadButtonClicked()"
        [disabled]="isWholeGridEmptyForSelectedDate ? true : false"
        [noMargin]="true"
      >
        <eds-icon type="download" size="small"></eds-icon>
        {{ "products.attribution-download-button-label" | translate }}
        ({{ "products.xls-file-extension" | translate }})
      </button>
    </div>
  </div>

  <!-- Grid data type toggle -->
  <div edsRow edsSpacing="md">
    <div edsCol>
      <eds-toggle
        [toggleButtons]="gridDataTypeToggle"
        (toggleActive)="onGridDataTypeUpdate($event)"
      ></eds-toggle>
    </div>
  </div>

  <!-- Table layout when grid data exists' -->
  <div
    edsRow
    *ngIf="!isWholeGridEmptyForSelectedDate; else wholeGridDataEmptyMessage"
  >
    <div
      edsCol
      [columnNumbers]="{ s: '4', m: '8', l: '12' }"
      class="table--wrapper"
    >
      <div class="table--scroll">
        <table class="table">
          <!-- Common table headers for both grid data type -->
          <thead class="table__thead">
            <!-- First table header row for group labels -->
            <tr class="table__tr">
              <th
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="2"
              >
                {{ "products.as-of" | translate }} {{ selectedAsOfDate }}
              </th>
              <th
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="3"
              >
                {{ fundName }} (%)
              </th>
              <th
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="3"
              >
                {{ bmName }} (%)
              </th>
              <th
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="3"
              >
                {{ "products.attribution-variation-header-title" | translate }}
                (%)
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="5"
              >
                {{ "products.attribution-currency-header-title" | translate }}
                (%)
                <p class="small">
                  {{
                    "products.attribution-currency-header-sub-title" | translate
                  }}
                </p>
              </th>
              <th
                class="table__th table__th--no-bg small bold text-align-left"
                colspan="4"
              >
                {{
                  "products.attribution-attribution-header-title" | translate
                }}
                (%)
              </th>
            </tr>

            <!-- Second table header row for column labels-->
            <tr class="table__tr">
              <!-- Toggle all button -->
              <th class="table__th small bold text-align-left" colspan="2">
                <eds-link-item
                  *ngIf="!isExpanded"
                  theme="dark"
                  [title]="'products.expand-all' | translate"
                  [useSmallText]="true"
                  [bold]="true"
                  (click)="toggleAll($event)"
                ></eds-link-item>
                <eds-link-item
                  *ngIf="isExpanded"
                  theme="dark"
                  [title]="'products.collapse-all' | translate"
                  [useSmallText]="true"
                  [bold]="true"
                  (click)="toggleAll($event)"
                ></eds-link-item>
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_AVG_WEIGHT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_RETURN" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_CONTRIBUTION" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_AVG_WEIGHT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_RETURN" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_CONTRIBUTION" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_AVG_WEIGHT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_RETURN" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.PORT_CONTRIBUTION" | translate }}
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th small bold text-align-right"
              >
                {{ "pds.ALLOC_EFFECT" | translate }}
                {{ "products.attribution-currency-local" | translate }}
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th small bold text-align-right"
              >
                {{ "pds.SELECT_EFFECT" | translate }}
                {{ "products.attribution-currency-local" | translate }}
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th small bold text-align-right"
              >
                {{ "pds.INTERACT_EFFECT" | translate }}
                {{ "products.attribution-currency-local" | translate }}
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th small bold text-align-right"
              >
                {{ "pds.TOTAL_EFFECT" | translate }}
                {{ "products.attribution-currency-local" | translate }}
              </th>
              <th
                *ngIf="showCurrencyAttribution"
                class="table__th small bold text-align-right"
              >
                {{ "pds.CURRENCY_EFFECT" | translate }}
                {{ "products.attribution-currency-local" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.ALLOC_EFFECT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.SELECT_EFFECT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.INTERACT_EFFECT" | translate }}
              </th>
              <th class="table__th small bold text-align-right">
                {{ "pds.TOTAL_EFFECT" | translate }}
              </th>
            </tr>
          </thead>

          <!-- Table body layout when grid data type is 'sector' -->
          <tbody
            *ngIf="selectedGridDataType === 'sector' && selectedSectorTotalData"
            class="table__body"
          >
            <tr class="table__tr">
              <td class="table__td small bold text-align-left" colspan="2">
                {{ "products.attribution-sector-industry" | translate }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.portfolio.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.portfolio.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.portfolio
                    .contributionToReturn
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.benchmark.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.benchmark.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.benchmark
                    .contributionToReturn
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.variation.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.variation.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.variation
                    .contributionToReturn
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedSectorTotalData.totalData.currency.allocationEffect
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{ selectedSectorTotalData.totalData.currency.selectionEffect }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedSectorTotalData.totalData.currency.interactionEffect
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{ selectedSectorTotalData.totalData.currency.totalEffect }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedSectorTotalData.totalData.currency.totalCurrencyEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.attribution.allocationEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.attribution.selectionEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedSectorTotalData.totalData.attribution
                    .interactionEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedSectorTotalData.totalData.attribution.totalEffect }}
              </td>
            </tr>
            <ng-container
              *ngFor="let sector of selectedSectorTotalData.sectors"
            >
              <tr class="table__tr">
                <td
                  class="table__td table__td--padding-right-none table__td--sector"
                  colspan="2"
                >
                  <div edsFlexbox alignItems="baseline">
                    <button
                      edsButton="icon-only"
                      (click)="toggleRow($event, 'sector', sector)"
                    >
                      <eds-icon
                        *ngIf="sector.isExpanded"
                        type="carrot-down"
                        size="small"
                      ></eds-icon>
                      <eds-icon
                        *ngIf="!sector.isExpanded"
                        type="carrot-right"
                        size="small"
                      ></eds-icon>
                    </button>
                    <span
                      class="text-primary"
                      (click)="toggleRow($event, 'sector', sector)"
                      >{{ sector.sectorName }}</span
                    >
                  </div>
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.portfolio.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.portfolio.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.portfolio.contributionToReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.benchmark.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.benchmark.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.benchmark.contributionToReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.variation.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.variation.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.variation.contributionToReturn }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ sector.sectorData.currency.allocationEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ sector.sectorData.currency.selectionEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ sector.sectorData.currency.interactionEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ sector.sectorData.currency.totalEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ sector.sectorData.currency.totalCurrencyEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.attribution.allocationEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.attribution.selectionEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.attribution.interactionEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ sector.sectorData.attribution.totalEffect }}
                </td>
              </tr>
              <ng-container *ngIf="sector.isExpanded">
                <ng-container *ngFor="let industry of sector.industries">
                  <tr class="table__tr">
                    <td class="table__td"></td>
                    <td class="table__td text-align-left">
                      {{ industry.industryName }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.portfolio.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.portfolio.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.portfolio.contributionToReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.benchmark.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.benchmark.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.benchmark.contributionToReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.variation.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.variation.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.variation.contributionToReturn }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ industry.industryData.currency.allocationEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ industry.industryData.currency.selectionEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ industry.industryData.currency.interactionEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ industry.industryData.currency.totalEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ industry.industryData.currency.totalCurrencyEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.attribution.allocationEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.attribution.selectionEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.attribution.interactionEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ industry.industryData.attribution.totalEffect }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>

          <!-- Table body layout when grid data type is 'country' -->
          <tbody
            *ngIf="
              selectedGridDataType === 'country' && selectedCountryTotalData
            "
            class="table__body"
          >
            <tr class="table__tr">
              <td class="table__td small bold text-align-left" colspan="2">
                {{ "products.attribution-region-country" | translate }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.portfolio.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.portfolio.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.portfolio
                    .contributionToReturn
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.benchmark.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.benchmark.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.benchmark
                    .contributionToReturn
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.variation.averageWeight }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.variation.totalReturn }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.variation
                    .contributionToReturn
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedCountryTotalData.totalData.currency.allocationEffect
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedCountryTotalData.totalData.currency.selectionEffect
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedCountryTotalData.totalData.currency.interactionEffect
                }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{ selectedCountryTotalData.totalData.currency.totalEffect }}
              </td>
              <td
                *ngIf="showCurrencyAttribution"
                class="table__td text-align-right"
              >
                {{
                  selectedCountryTotalData.totalData.currency
                    .totalCurrencyEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.attribution
                    .allocationEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.attribution.selectionEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{
                  selectedCountryTotalData.totalData.attribution
                    .interactionEffect
                }}
              </td>
              <td class="table__td text-align-right">
                {{ selectedCountryTotalData.totalData.attribution.totalEffect }}
              </td>
            </tr>
            <ng-container
              *ngFor="let region of selectedCountryTotalData.regions"
            >
              <tr class="table__tr">
                <td
                  class="table__td table__td--padding-right-none table__td--region"
                  colspan="2"
                >
                  <div edsFlexbox alignItems="baseline">
                    <button
                      edsButton="icon-only"
                      (click)="toggleRow($event, 'country', region)"
                    >
                      <eds-icon
                        *ngIf="region.isExpanded"
                        type="carrot-down"
                        size="small"
                      ></eds-icon>
                      <eds-icon
                        *ngIf="!region.isExpanded"
                        type="carrot-right"
                        size="small"
                      ></eds-icon>
                    </button>
                    <span
                      class="text-primary"
                      (click)="toggleRow($event, 'country', region)"
                      >{{ region.regionName }}</span
                    >
                  </div>
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.portfolio.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.portfolio.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.portfolio.contributionToReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.benchmark.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.benchmark.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.benchmark.contributionToReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.variation.averageWeight }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.variation.totalReturn }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.variation.contributionToReturn }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ region.regionData.currency.allocationEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ region.regionData.currency.selectionEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ region.regionData.currency.interactionEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ region.regionData.currency.totalEffect }}
                </td>
                <td
                  *ngIf="showCurrencyAttribution"
                  class="table__td text-align-right"
                >
                  {{ region.regionData.currency.totalCurrencyEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.attribution.allocationEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.attribution.selectionEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.attribution.interactionEffect }}
                </td>
                <td class="table__td text-align-right">
                  {{ region.regionData.attribution.totalEffect }}
                </td>
              </tr>
              <ng-container *ngIf="region.isExpanded">
                <ng-container *ngFor="let country of region.countries">
                  <tr class="table__tr">
                    <td class="table__td"></td>
                    <td class="table__td text-align-left">
                      {{ country.countryName }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.portfolio.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.portfolio.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.portfolio.contributionToReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.benchmark.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.benchmark.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.benchmark.contributionToReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.variation.averageWeight }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.variation.totalReturn }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.variation.contributionToReturn }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ country.countryData.currency.allocationEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ country.countryData.currency.selectionEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ country.countryData.currency.interactionEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ country.countryData.currency.totalEffect }}
                    </td>
                    <td
                      *ngIf="showCurrencyAttribution"
                      class="table__td text-align-right"
                    >
                      {{ country.countryData.currency.totalCurrencyEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.attribution.allocationEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.attribution.selectionEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.attribution.interactionEffect }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ country.countryData.attribution.totalEffect }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- No table data message -->
  <ng-template #wholeGridDataEmptyMessage>
    <span>{{
      "products.attribution-no-data-for-selected-date" | translate
    }}</span>
  </ng-template>
</div>
